import React, { useRef, useImperativeHandle, forwardRef } from 'react';

import { DataChange } from 'devextreme/common/grids';

import FieldGrid, { FieldGridHandle } from './FieldGrid';

import AIFieldMappingDto from '../../classes/dtos/pathaimodule/AIFieldMappingDto';

import TransformationCapabilitiesDto from '../../classes/dtos/transformationmodule/TransformationCapabilitiesDto';
import PathAIMappingCapabilitiesDto from '../../classes/dtos/pathaimodule/PathAIMappingCapabilitiesDto';


interface AIExposedFieldsProps {
    MappingChanges: DataChange[] | undefined;
    SetMappingChanges(changes: DataChange[], origin: AIFieldMappingDto[]): void;

    Capabilities: PathAIMappingCapabilitiesDto[];
    TransformationsCapabilities: TransformationCapabilitiesDto[];
    Mapping: AIFieldMappingDto[];
    IsSimpleFilterMode: boolean;
    FiltersEnabled: boolean;
    TableReferenceId: number;

    AdvancedFilterMode: boolean;
    SetAdvancedFilterMode(value: boolean): void;
    AdvancedFilterModeLocked: boolean;

    SelectionIds: number[];
    SetSelectionIds(ids: number[]): void;
}

export interface AIExposedFieldsHandle {
    Save: () => void;
}

const AIExposedFields = forwardRef<AIExposedFieldsHandle, AIExposedFieldsProps>(({ MappingChanges, SetMappingChanges, Capabilities, TransformationsCapabilities, Mapping, IsSimpleFilterMode, FiltersEnabled, TableReferenceId, AdvancedFilterMode, SetAdvancedFilterMode, AdvancedFilterModeLocked, SelectionIds, SetSelectionIds }, ref) => {

    useImperativeHandle(ref, () => ({
        Save() {
            if (fieldGridRef.current) {
                fieldGridRef.current.Save();
            }
        }
    }));

    const fieldGridRef = useRef<FieldGridHandle>(null);

    return (
        <div style={{ width: '100%', height: '100%', position: 'relative', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', display: 'inline-flex' }}>
            <div style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', display: 'inline-flex' }}>
                <FieldGrid
                    ref={fieldGridRef}
                    MappingChanges={MappingChanges}
                    SetMappingChanges={SetMappingChanges}

                    Capabilities={Capabilities}
                    TransformationsCapabilities={TransformationsCapabilities}
                    Mapping={Mapping}
                    IsSimpleFilterMode={IsSimpleFilterMode}
                    FiltersEnabled={FiltersEnabled}
                    TableReferenceId={TableReferenceId}
                    AdvancedFilterMode={AdvancedFilterMode}
                    SetAdvancedFilterMode={SetAdvancedFilterMode}
                    AdvancedFilterModeLocked={AdvancedFilterModeLocked}
                    SelectionIds={SelectionIds}
                    SetSelectionIds={SetSelectionIds}/>
            </div>
        </div>
    );
});

export default AIExposedFields;